import {
  GetProfilesDocument,
  ScreenProfile,
  ValidateUserPinDocument,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const getProfiles = async (departmentIds: string[]) => {
  const response = await apolloClient.query({
    query: GetProfilesDocument,
    variables: {
      filter: {
        departments: departmentIds,
      },
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.profiles) {
    return response.data.profiles;
  }

  throw new SentryGraphQLError('api.profiles.getProfiles', response);
};

const validateUserPin = async (profile: ScreenProfile) => {
  const response = await apolloClient.query({
    query: ValidateUserPinDocument,
    variables: { profile },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.user?.validatePin) {
    return response.data.user.validatePin;
  }

  throw new SentryGraphQLError('api.profiles.validateUserPin', response);
};

export default {
  getProfiles,
  validateUserPin,
};
